import {
  AccountBookFilled,
  AccountBookOutlined,
  GlobalOutlined,
  MenuOutlined,
  ProjectOutlined,
  SwapOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import SubMenu from "antd/lib/menu/SubMenu";
import React from "react";
import { useNavigate } from "react-router-dom";
// import icons
import {
  RiAccountBoxLine,
  RiCurrencyFill,
  RiCurrencyLine,
  RiDashboardLine,
} from "react-icons/ri";

import { useSelector } from "react-redux";
import "../../../assets/styles/sidebar.less";
import { RootState } from "../../types/common";
import {
  ROUTE_DASHBOARD,
  ROUTE_MANAGE_DEPARTMENT,
  ROUTE_MANAGE_STAFF,
  ROUTE_MANAGE_PROJECT,
  ROUTE_MILESTONES,
  ROUTE_MANAGE_BILLING_CYCLE,
  ROUTE_MANAGE_VENDOR,
  ROUTE_BILLING_SUMMARY,
  ROUTE_MANAGE_ACCOUNT,
  ROUTE_MANAGE_SUB_DEPARTMENT,
  ROUTE_MANAGE_FOREX,
} from "../../routes/private.routes";
import { BiBuilding, BiBuildingHouse, BiHome } from "react-icons/bi";
import { allPermissions } from "../../constants/constants";

const MENU_ITEMS = [
  // {
  //   label: "Dashboard",
  //   key: "dashboard",
  //   route: ROUTE_DASHBOARD,
  //   icon: (
  //     <span role="img" className="anticon">
  //       <RiDashboardLine />
  //     </span>
  //   ),
  //   children: [],
  // },
  {
    label: "Staff",
    key: "staff",
    icon: <UserOutlined />,
    route: "",
    permission: [allPermissions.VIEW_STAFF],
    children: [
      {
        label: "Manage Staff",
        key: "manage-staff",
        route: ROUTE_MANAGE_STAFF,
      },
    ],
  },
  {
    label: "Vendor",
    key: "vendor",
    icon: (
      <span className="anticon ">
        <BiHome />
      </span>
    ),
    route: "",
    permission: [allPermissions.VIEW_VENDOR],
    children: [
      {
        label: "Manage Vendor",
        key: "manage-vendor",
        route: ROUTE_MANAGE_VENDOR,
      },
    ],
  },
  {
    label: "Client",
    key: "account",
    icon: (
      <span className="anticon ">
        <AccountBookOutlined />
      </span>
    ),
    route: "",
    permission: [allPermissions.VIEW_ACCOUNT],
    children: [
      {
        label: "Manage Client",
        key: "manage-client",
        route: ROUTE_MANAGE_ACCOUNT,
      },
    ],
  },
  {
    label: "Project",
    key: "project",
    icon: <ProjectOutlined />,
    route: "",
    permission: [],
    children: [
      {
        label: "Manage Project",
        key: "manage-project",
        route: ROUTE_MANAGE_PROJECT,
        permission: [allPermissions.VIEW_PROJECT]
      },
      {
        label: "Milestones",
        key: "milestones",
        route: ROUTE_MILESTONES,
        permission: [allPermissions.VIEW_PROJECT]
      },
      // {
      //   label: "Manage Billing Cycle",
      //   key: "manage-billing-cycle",
      //   route: ROUTE_MANAGE_BILLING_CYCLE,
      // },
      {
        label: "Billing Summary",
        key: "billing-summary",
        route: ROUTE_BILLING_SUMMARY,
        permission: [allPermissions.VIEW_BILLING_SUMMARY]
      },
    ],
  },
  {
    label: "Department",
    key: "department",
    icon: (
      <span className="anticon ">
        <BiBuilding />
      </span>
    ),
    route: "",
    permission: [],
    children: [
      {
        label: "Manage Department",
        key: "manage-department",
        route: ROUTE_MANAGE_DEPARTMENT,
        permission: [allPermissions.VIEW_DEPARTMENT],
      },
      {
        label: "Manage Sub Department",
        key: "manage-sub-department",
        route: ROUTE_MANAGE_SUB_DEPARTMENT,
        permission: [allPermissions.VIEW_SUBDEPARTMENT],
      },
    ],
  },
  {
    label: "Forex",
    key: "forex",
    icon: <GlobalOutlined />,
    route: "",
    permission: [allPermissions.VIEW_FOREX],
    children: [
      {
        label: "Manage Forex",
        key: "manage-forex",
        route: ROUTE_MANAGE_FOREX,
      },
    ],
  },
];

const MenuComponent: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  const role = "admin";
  const { myPermissions } = useSelector((state: RootState) => state.auth);
  const userPermissions = myPermissions?.map((rp: any) => rp.permission?.name) || [];
  console.log(userPermissions, "userPermissions");

  const userPermissionSet = new Set(userPermissions);

  const hasPermission = (requiredPermissions: string[]): boolean => {
    if (!requiredPermissions || requiredPermissions.length === 0) {
      return true;
    }
    return requiredPermissions.some((permission) =>
      userPermissionSet.has(permission)
    );
  };

  const filterMenuItemsByPermissions = (menuItems: any[]): any[] => {
    return menuItems.filter((item) => {
      if (!hasPermission(item.permission)) {
        return false;
      }

      if (item.children) {
        const filteredChildren = item.children.filter((child: any) =>
          hasPermission(child.permission)
        );

        if (filteredChildren.length > 0) {
          item.children = filteredChildren;
          return true;
        }
        return false;
      }

      return true;
    });
  };
  const FILTERED_MENU_ITEMS = filterMenuItemsByPermissions([...MENU_ITEMS]);
  return (
    <>
      <Menu
        onClick={(e: any) => {
          if (e.key !== "") {
            navigate(e.key);
          }
        }}
        // defaultOpenKeys={[MENU_ITEMS[0].label]}
        mode="horizontal"
        theme="dark"
        itemIcon={true}
        expandIcon={<MenuOutlined />}
        overflowedIndicator={<MenuOutlined />}
      >
        {FILTERED_MENU_ITEMS.map((menuGroup: any) => {
          if (
            [...(menuGroup?.permission || []), "admin"].indexOf(role) !== -1
          ) {
            if (menuGroup?.children?.length === 0) {
              return (
                <Menu.Item
                  key={menuGroup.route}
                  icon={menuGroup.icon}
                  title={menuGroup.label}
                >
                  {menuGroup.label}
                </Menu.Item>
              );
            } else {
              return (
                <SubMenu
                  key={menuGroup.label}
                  icon={menuGroup.icon}
                  title={menuGroup.label}
                >
                  {menuGroup.children &&
                    menuGroup.children.map((menuItem: any) => {
                      if (
                        [...(menuItem?.permission || []), "admin"].indexOf(
                          role
                        ) !== -1
                      ) {
                        return (
                          <Menu.Item icon={menuItem.icon} key={menuItem.route}>
                            {menuItem.label}
                          </Menu.Item>
                        );
                      }
                    })}
                </SubMenu>
              );
            }
          }
        })}
      </Menu>
    </>
  );
};

export default MenuComponent;
